var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fblogo_2",
    "data-name": "fblogo 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.65 27.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .fblogo-1 {\n        fill: #000;\n      }\n\n      .fblogo-1, .fblogo-2 {\n        stroke-width: 0px;\n      }\n\n      .fblogo-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fblogo_1",
    "data-name": "fblogo 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fblogo-1",
    d: "M27.65,13.83C27.65,6.19,21.46,0,13.83,0S0,6.19,0,13.83c0,6.9,5.06,12.62,11.67,13.66v-9.66h-3.51v-4h3.51v-3.05c0-3.47,2.06-5.38,5.22-5.38,1.51,0,3.09.27,3.09.27v3.4h-1.74c-1.72,0-2.25,1.07-2.25,2.16v2.59h3.83l-.61,4h-3.22v9.66c6.61-1.04,11.67-6.76,11.67-13.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fblogo-2",
    d: "M19.21,17.82l.61-4h-3.83v-2.59c0-1.09.54-2.16,2.25-2.16h1.74v-3.4s-1.58-.27-3.09-.27c-3.16,0-5.22,1.91-5.22,5.38v3.05h-3.51v4h3.51v9.66c.7.11,1.43.17,2.16.17s1.46-.06,2.16-.17v-9.66h3.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb-logo.bcb347d16a7f735714ec81aafd24afbb.svg";
export { ForwardRef as ReactComponent };